// import axios from "@/axios"; 
import axiosSync from "@/axiosSync";
// import axios from "@/axios";

export function usePortInfoEponCDATACLODEApi() {
  async function getEponClodeBasicInfo(olt_id) {
    const response = await axiosSync.get(`/cdata-epon-cloude/api?oltid=${olt_id}&url=${process.env.VUE_APP_API_BASE_URL}`);
    return response.data;
  }
  async function getEponClodePonPortData(olt_id) {
    const response = await axiosSync.get(`/cdata-epon-cloude/api?oltid=${olt_id}&dta=portinfo&url=${process.env.VUE_APP_API_BASE_URL}`);
    return response.data;
  }
  /* async function getEponClodeFiberDownData(olt_id) {
    const response = await axiosSync.get(`/cdata-epon-cloude/api?oltid=${olt_id}&dta=fiberdown`);
    return response.data;
  }
 async function getEponClodeSingleOnuData(port_number, olt_id) {
    const matches = port_number.match(/(GPON|EPON)?\d*\/(\d+):(\d+)/i);
    
    if (!matches) {
      throw new Error(`Invalid port number format: ${port_number}. Expected format like GPON0/1:1 or EPON1/1:1`);
    }
    
    const ponid = matches[2];  
    const onuid = matches[3];  
    
    console.log('VSOL Service - Parsed:', { ponid, onuid });
    
    const url = `/cdata-epon-cloude/api?oltid=${olt_id}&dta=onustatus&onu_id=${onuid}&pon_id=${ponid}`;
    console.log('VSOL Service - API URL:', url);
    
    const response = await axiosSync.get(url);
    console.log('VSOL Service - Response received');
    
    return response.data;
}
  async function getEponClodeMindMac(olt_id,macaddr) {
    const response = await axiosSync.get(`/cdata-epon-cloude/api?oltid=${olt_id}&dta=macfind&MacAddr=${macaddr}`);
    return response.data;
  } */



  return {
    getEponClodeBasicInfo,
    getEponClodePonPortData,
    /* getEponClodeFiberDownData,
    getEponClodeSingleOnuData,
    getEponClodeMindMac */
  };
}
